// The browser's storage for the comms live layer: localStorage, keyed per
// user and site so two people on one browser never see each other's state.
// Storage can be unavailable (private windows, cleared site data); the
// consumers treat a failure as "nothing saved" and keep working in memory.
import type { IReadQueueStore } from '@d-orca/shared/client/comms';
import type { IUnreadStorage } from '@d-orca/shared/client/hooks';

/** Where read acks wait out a closed tab. */
export function readQueueStore(userId: string, siteId: string): IReadQueueStore {
  const key = `comms:readQueue:v1:${userId}:${siteId}`;
  return {
    async load() {
      return localStorage.getItem(key);
    },
    async save(value) {
      localStorage.setItem(key, value);
    },
  };
}

/** Where the unread badges' first-paint cache lives; reads synchronously, so the store starts full. */
export const unreadStorage: IUnreadStorage = {
  getSync: (key) => localStorage.getItem(key),
  get: async (key) => localStorage.getItem(key),
  set: (key, value) => localStorage.setItem(key, value),
};
